import BusinessWireLogo from 'assets/images/news/businesswire-x2.png';

export const mediaAboutUsConfig = {
  logo: BusinessWireLogo,
  title: 'Introducing Joblio – The Future of Ethical Recruitment',
  date: 'May 12, 2025',
  description:
    'Joblio, a global ethical recruitment platform, is tackling the broken labor migration system—plagued by exploitative intermediaries, excessive recruitment fees, and widespread human rights abuses. Today, Joblio launches its technology platform as the future of ethical recruitment, ensuring fair, transparent, and cost-free hiring for migrant workers worldwide. While employers pay for access to the platform and vetted talent, Joblio guarantees that workers never bear the financial burden of recruitment—eliminating a major driver of exploitation.',
  link: 'https://www.businesswire.com/news/home/20250512628048/en/Introducing-Joblio-The-Future-of-Ethical-Recruitment',
  linkText: 'Read more'
};
